export default __webpack_public_path__ + "static/media/solana-step-success.ca645545.svg";